import { useLocation, useNavigate } from 'react-router-dom'
import api from '@utils/api'
import { useSecurityContext } from '@components/Navigation/SecurityContext'
import { useUserSettings } from '@hooks/settings'
import { useThemeContext } from '@gravitate-js/excalibrr'
import {
  getDisplayTimezoneString,
  getShowNetworkTimezone,
  setDisplayTimezoneString,
  setShowNetworkTimezone,
} from '@utils/general'

function SSOAuth() {
  const { setScopes } = useSecurityContext()
  const { setupSettings, getSetting } = useUserSettings()
  const navigate = useNavigate()
  const { isDarkTheme } = useThemeContext()
  const location = useLocation()

  const getQueryParam = (name) => {
    const searchParams = new URLSearchParams(location.search)
    return searchParams.get(name)
  }

  const token = getQueryParam('token')

  if (!token) return <>No token!</>

  api.sso_authenticate(token, setScopes, setupSettings).then((isLoggedIn) => {
    let shouldReload = false
    if (isLoggedIn) {
      navigate('/')

      getSetting('USE_NETWORK_TIMEZONE').then((showNetworkTimezone) => {
        shouldReload = getShowNetworkTimezone() !== showNetworkTimezone
        setShowNetworkTimezone(showNetworkTimezone)
      })

      getSetting('SHOW_TIMEZONE_STRING').then((showTimezoneString) => {
        shouldReload = getDisplayTimezoneString() !== showTimezoneString
        setDisplayTimezoneString(showTimezoneString)
      })

      getSetting('TYPE_OF_THEME').then((theme) => {
        if (theme === 'DARK_MODE' && !isDarkTheme) {
          shouldReload = true
          localStorage.setItem('TYPE_OF_THEME', theme)
        } else if (theme === 'LIGHT_MODE' && isDarkTheme) {
          shouldReload = true
          localStorage.setItem('TYPE_OF_THEME', theme)
        }
      })
      if (shouldReload) window.location.reload()
    }
  })

  return (
    <div>
      <h1>SSO Auth</h1>
      If you got here something didnt redirect, check logs
    </div>
  )
}

export default SSOAuth
